export default __webpack_public_path__ + "static/media/example_check.95b16f53.png";